module.exports = __webpack_public_path__ + "img/box1.fc9f1104.png";